import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

const TraderLayout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="bg-white shadow-sm">
        
         
          <Navbar />
        
      </div>
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default TraderLayout;
